import { render, staticRenderFns } from "./BeaconHistoryListPage.vue?vue&type=template&id=08a8ff45&scoped=true&"
import script from "./BeaconHistoryListPage.vue?vue&type=script&lang=js&"
export * from "./BeaconHistoryListPage.vue?vue&type=script&lang=js&"
import style0 from "./BeaconHistoryListPage.vue?vue&type=style&index=0&id=08a8ff45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a8ff45",
  null
  
)

export default component.exports